const STORAGE_KEY = 'viewedProducts3dids';

const readIds = () => {
  try {
    const ids = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(ids) ? ids.map(String) : [];
  } catch {
    return [];
  }
};

const writeIds = (ids) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {}
};

class RecentlyViewed3dids extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded !== undefined || window.Shopify?.designMode) return;

    const current = this.dataset.productId;
    const max = Number(this.dataset.max) || 8;
    const stored = readIds();

    if (current) writeIds([current, ...stored.filter((id) => id !== current)].slice(0, max + 1));

    const ids = stored.filter((id) => id !== current).slice(0, max);
    if (ids.length) this.load(ids);
  }

  async load(ids) {
    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));

    try {
      const response = await fetch(url);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = doc.querySelector('.shopify-section');
      if (!incoming || !incoming.querySelector('[data-viewed-id-3dids]')) return;

      const section = this.closest('.shopify-section');
      if (!section) return;

      section.replaceChildren(...incoming.childNodes);
      document.dispatchEvent(new Event('shopify:section:load'));
    } catch {}
  }
}

if (!customElements.get('recently-viewed-3dids')) {
  customElements.define('recently-viewed-3dids', RecentlyViewed3dids);
}
